<script setup lang="ts">
import {
  SHARE_WHATSAPP_URL,
  SHARE_TELEGRAM_URL,
  SHARE_OK_URL,
  SHARE_VK_URL,
} from '@/shared/constants/urlConstants';
import { ROOT_URL_HOST } from '@/shared/constants/contactConstants';

interface ShareItem {
  id: number;
  url: string;
  icon: string;
  label: string;
}

const emit = defineEmits<{
  (e: 'copy'): void;
}>();

const route = useRoute();
const currentRoute: ComputedRef<string> = computed(
  () => `${ROOT_URL_HOST}${route.fullPath}`,
);

const shareItems: ComputedRef<ShareItem[]> = computed(() => [
  {
    id: 1,
    url: `${SHARE_WHATSAPP_URL}${currentRoute.value}`,
    icon: 'Whatsapp',
    label: 'Поделиться в WhatsApp',
  },
  {
    id: 2,
    url: `${SHARE_TELEGRAM_URL}${currentRoute.value}`,
    icon: 'Telegram',
    label: 'Поделиться в Telegram',
  },
  {
    id: 3,
    url: `${SHARE_OK_URL}${currentRoute.value}`,
    icon: 'Odnoklassniki',
    label: 'Поделиться в Одноклассниках',
  },
  {
    id: 4,
    url: `${SHARE_VK_URL}${currentRoute.value}`,
    icon: 'Vk',
    label: 'Поделиться во ВКонтакте',
  },
]);

const copyHandler = (): void => {
  emit('copy');
};
</script>

<template>
  <div class="journal-article-social">
    <div class="journal-article-social__text">
      <AppIcon class="journal-article-social__icon" name="Share" />
      Поделиться:
    </div>
    <ul class="journal-article-social__list">
      <li
        v-for="item in shareItems"
        :key="item.id"
        class="journal-article-social__list-item"
      >
        <a
          class="journal-article-social__button"
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
          :aria-label="item.label"
        >
          <AppIcon class="journal-article-social__icon" :name="item.icon" />
        </a>
      </li>
      <li class="journal-article-social__list-item">
        <button
          class="journal-article-social__button"
          type="button"
          aria-label="Скопировать ссылку"
          @click.prevent="copyHandler"
        >
          <AppIcon class="journal-article-social__icon" name="Chain" />
        </button>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.journal-article-social {
  display: flex;
  gap: @main-size;

  &__text {
    display: flex;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    gap: @main-size;
  }

  &__icon {
    width: @size-x5;
    height: @size-x5;
  }

  &__list {
    display: flex;
    align-items: center;
    gap: @size-x3;
  }
}
</style>
